import { render, staticRenderFns } from "./RelatedSearchesDrawer.vue?vue&type=template&id=909d7c6e"
import script from "./RelatedSearchesDrawer.vue?vue&type=script&lang=js"
export * from "./RelatedSearchesDrawer.vue?vue&type=script&lang=js"
import style0 from "./RelatedSearchesDrawer.vue?vue&type=style&index=0&id=909d7c6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports